<template>
  <AppLayout>
    <template #prepend />
    <template #default />
    <template #append />
  </AppLayout>
</template>

<script lang="ts" setup>
  // import components shared
  import AppLayout from '@/layouts/AppLayout/AppLayout.vue';
</script>
